import { useMemo } from 'react'
import { personName } from 'Data/format.js'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(user => ({
      id: user.id,
      text: personName(user.vaxiom_person),
    }))
  }, [data])
}
